import styled from 'styled-components'
import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca'
import { leagueIds, ratePlanCodes, sportIds } from 'src/constants'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-dazn.png"
        video="https://assets-imgx.fubo.tv/marketing/lp/videos/compressed/DAZN_fubo_sports_16x9_3Mb.mp4"
        videoMobile="https://assets-imgx.fubo.tv/marketing/lp/videos/mobile/DAZN_fubo_sports_1x1_3Mb.mp4"
        title="Every NFL game & top-tier soccer"
        subtitle="Stream NFL, UCL, Euro qualifiers & more with DAZN. Plus EPL and Serie A."
        hasPlanCardsTabs={true}
        offerCode={ratePlanCodes.canada_sports_pro_mo}
        forceAnchorLink={false}
        networkSet="canada_dazn"
        planCardsConfig={{
          plans: [canadaPlanData.sports_pro],
          activeTab: 'monthly',
        }}
        channelPlanCode={ratePlanCodes.canada_sports_pro_mo}
        networkHeadline="Stream the sports you love without cable"
        additionalFAQs={additionalFAQs}
        platformImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/devices-ca-dazn.png"
        matchtickerSportId={sportIds.Football}
        matchtickerLeagueName="NFL"
        matchtickerLeagueId={leagueIds.NFL}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .planCard .planCard__content .planCard__header .planCard__price {
    flex-wrap: wrap !important;
  }
  .planCard.planCard-with-image {
    padding-top: 182px;
  }
`

const additionalFAQs = [
  {
    question: 'Can I watch Philadelphia Eagles games on Fubo in Canada?',
    answer:
      'Yes, you can watch Philadelphia Eagles games on Fubo in Canada. They are available on NFL Game Pass with DAZN. To watch NFL on Fubo, subscribe to either the DAZN standalone plan or Sports Pro, which includes DAZN.',
  },
  {
    question: 'Can I find Baltimore Ravens games on Fubo Canada?',
    answer:
      'Yes, Baltimore Ravens games are available on Fubo. Ravens games are available through NFL Game Pass with DAZN. DAZN is available as a standalone plan or included in Sports Pro.',
  },
  {
    question: 'Are Kansas City Chiefs games available to watch in Canada with Fubo?',
    answer: 'Yes, Kansas City Chiefs games are available on Fubo via NFL Game Pass with DAZN.',
  },
  {
    question: 'Can I watch Buffalo Bills games on NFL Game Pass with Fubo?',
    answer:
      'Yes, Buffalo Bills games are available on NFL Game Pass with Fubo. NFL Game Pass is included with DAZN, which is available as a standalone plan or in our Sports Pro plan.',
  },
  {
    question: 'Are Detroit Lions games available with Fubo?',
    answer:
      'Yes, in Canada you can watch Detroit Lions games on NFL Game Pass with Fubo. Just subscribe to the DAZN standalone plan or Fubo’s Sports Pro plan, which includes DAZN and NFL Game Pass.',
  },
  {
    question: 'Is NFL Game Pass available with Fubo?',
    answer:
      'Yes, NFL Game Pass is available on DAZN with Fubo in Canada. NFL Game Pass includes every regular season and postseason NFL game, NFL Redzone, NFL Network and more. To watch NFL Game Pass on Fubo, you have two plan options: the DAZN standalone plan, and the Sports Pro plan. Both plans include DAZN, which provides access to NFL Game Pass.',
  },
  {
    question: 'Can I watch live NFL games on Fubo in Canada?',
    answer:
      'Yes, Fubo offers live coverage of NFL games in Canada through NFL Game Pass. NFL Game Pass has every game from every NFL team. To get NFL Game Pass on Fubo, subscribe to Fubo’s DAZN standalone plan or the Sports Pro plan.',
  },
  {
    question: 'How do I find specific NFL games on Fubo?',
    answer:
      'To find specific NFL games on Fubo, navigate to the Sports section or use the search bar to find teams. You can filter by NFL to see upcoming and live games.',
  },
  {
    question: 'Is there commentary and analysis for NFL games on Fubo?',
    answer:
      'Yes, NFL Game Pass includes commentary and analysis for NFL games. To watch NFL Game Pass on Fubo subscribe to our DAZN standalone plan or Sports Pro.',
  },
  {
    question: 'Can I watch NFL highlights on NFL RedZone with Fubo?',
    answer:
      'Yes, NFL RedZone is included via NFL Game Pass. Game in 40 and Sunday in 60 are also included. Fubo subscribers in Canada with DAZN in their plan have access to every regular season and postseason NFL game, as well as NFL RedZone for highlights. DAZN is available as a standalone plan and in our Sports Pro plan. ',
  },
  {
    question: 'How can I watch NFL highlights on Fubo?',
    answer:
      'You can watch NFL highlights on Fubo by navigating to the NFL section. Highlights are often available shortly after games conclude.',
  },
]
